import { forwardRef } from "react";
import OpenableLink from "./OpenableLink";

const UserProfileLink = forwardRef(function UserProfileLink(
  {
    userId,
    children,
    as: Tag = "p",
    search = "",
    className = "",
    linkClassName = "text-primary cursor-pointer hover:underline",
    ...rest
  },
  ref,
) {
  if (!userId) {
    return (
      <Tag ref={ref} className={className} {...rest}>
        {children}
      </Tag>
    );
  }

  return (
    <OpenableLink
      ref={ref}
      as={Tag}
      to={`/user/details/profile/${userId}${search}`}
      className={`${className} ${linkClassName}`.trim()}
      {...rest}
    >
      {children}
    </OpenableLink>
  );
});

export const renderUserCell = (user) =>
  user ? (
    <UserProfileLink userId={user.id} className="capitalize">
      {`${user.firstName || ""} ${user.lastName || ""}`.trim()}
    </UserProfileLink>
  ) : (
    <p>-</p>
  );

export default UserProfileLink;
